package smartTcm.components


import antd.badge.badge
import antd.button.button
import antd.card.card
import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.list.ListComponent
import antd.list.list
import antd.list.listItem
import antd.list.listItemMeta
import antd.message.message
import antd.modal.modal
import antd.radio.radioButton
import antd.radio.radioGroup
import antd.select.SelectComponent
import antd.select.optGroup
import antd.select.option
import antd.select.select
import antd.tag.tag
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.orm.mapping.MedicalRecord
import com.jingfangpai.common.orm.mapping.MedicalRecordSignSymptom
import com.jingfangpai.common.orm.mapping.enums.*
import external.select.filterOptionFun
import external.toJsObject
import kotlinext.js.Object
import kotlinext.js.js
import kotlinx.html.unsafe
import react.*
import react.dom.*
import react.router.dom.useHistory
import smartTcm.containers.SmartTcmWaitingAreaPageContext
import urlBase
import user.service.AuthService
import user.service.CurrentUserPermission

interface SmartTcmIndexProps : RProps {

}

data class SmartTcmIndexContextData(var placeHolderFunction: (param: String) -> Unit)

val SmartTcmWaitingArea = functionalComponent<SmartTcmIndexProps> { props ->

    val ctx = useContext(SmartTcmWaitingAreaPageContext)
    val (waitingList,setWaitingList) = useState(arrayOf<MedicalRecord>())
    var editingMedicalRecord by useState(MedicalRecord().apply {
        type = MedicalRecordType.诊治记录
        title = ""
        source = "后台录入"
        description = "无"
        prescriptionContent = ""
        patientId = "10da03c9289a11ecac40525422cdb422"
        status = MedicalRecordStatus.处理中
        createdOn = DateTime()
        createdBy = AuthService.getUserAuthData()?.id
    })
    var showEditForm by useState(false)
    val history = useHistory()

    fun getWaitingList(){
        ctx.getWaitingList({ resp->
           if(resp.ok()){
               setWaitingList(resp.data!!.toTypedArray())
           }else{
               message.error("获取候诊列表失败:${resp.message}")
           }
        },{
            message.error("获取候诊列表失败:${it.message}")
        })
    }

    useEffectOnce {
        getWaitingList()
    }

    div("SmartTcmWaitingArea") {
        attrs{
            jsStyle = js{
                padding = "40px"
            }
        }
        card {
            attrs{
                title = "待诊列表"
                extra = buildElement {
                    if(CurrentUserPermission.hasPerm(UserPermissionMedicalRecord.添加医案) || CurrentUserPermission.hasPerm(UserPermissionMedicalRecord.添加私有医案)){
                        button {
                            attrs{
                                onClick = {
                                    val _editing = Object.assign(MedicalRecord(), editingMedicalRecord)
                                    _editing.id = null
                                    _editing.createdOn = DateTime()
                                    editingMedicalRecord = _editing
                                    showEditForm = true
                                }
                            }
                            +"添加"
                        }
                    }
                }
            }
            list<MedicalRecord, ListComponent<MedicalRecord>> {
                attrs {
                    itemLayout = "horizontal"
                    dataSource = waitingList
                    header = buildElement {
                        h3 {
                            +"共有${waitingList.size}人"
                        }
                    }
                    renderItem = { item, index ->

                        listItem {
                            attrs{
                                actions = arrayOf(
                                    buildElement {
                                        button {
                                            attrs{
                                                size = "small"
                                                onClick = {
                                                    history.push(SmartTcmRoute.Diagnosis.link.url.replace(":medicalRecordId",item.id?:""))
                                                }
                                            }
                                            +"+诊治"
                                        }
                                    }!!
                                )
                            }
                            listItemMeta {
                                attrs {
                                    key = "${item.id}"
                                    id = "${item.id}"
                                    className = ""//if(props.keyword.isNotBlank() || contentContainsKey || commentContainsKey) "" else "hidden"
                                    avatar = buildElement {
                                        badge{
                                            attrs{
                                                overflowCount = 300
                                                count = index.toInt()+1
                                            }
                                        }
                                    }
                                    title = buildElement {
                                        div{
                                            h3{
                                                attrs {
                                                    unsafe {
                                                        + "${item.title}"
                                                    }
                                                    jsStyle = kotlinext.js.js {
                                                        display = "inline-block"
                                                    }
                                                }
                                            }
                                            div("meta-info") {
                                                this.attrs{
                                                    jsStyle = js {
                                                        display = "inline-block"
                                                    }
                                                }

                                                span {
                                                    attrs{
                                                        jsStyle = js {
                                                            marginLeft = "10px"
                                                        }
                                                    }
                                                    tag {
                                                        attrs.color = "blue"
                                                        +"${item.patientName?:""}"
                                                    }
                                                }
                                                span {
                                                    attrs{
                                                        jsStyle = js {
                                                            marginLeft = "10px"
                                                        }
                                                    }
                                                    +"["
                                                }
                                                span {
                                                    +"性别"
                                                    tag {
                                                        attrs.color = "blue"
                                                        +"${item.patientSex?:""}"
                                                    }
                                                }
                                                span {
                                                    +"日期"
                                                    tag {
                                                        attrs.color = "blue"
                                                        +"${item.createdOn?.toDateTimeString()?:""}"
                                                    }
                                                }
                                                if(!item.source.isNullOrBlank()){
                                                    span {
                                                        +"来源"
                                                        tag {
                                                            attrs.color = "blue"
                                                            +"${item.source?:""}"
                                                        }
                                                    }
                                                }
                                                span {
                                                    +"]"
                                                }
                                            }

                                        }
                                    }
                                    description = buildElement {
                                        div{
                                            div{
                                                attrs.unsafe {
                                                    +"${item.description?:""}"
                                                }
                                            }
                                            div{
                                                attrs{
                                                    jsStyle = js {
                                                        padding = "2px 5px"
                                                        border = "1px solid mediumslateblue"
                                                        display = "inline-block"
                                                    }
                                                }
                                                +"症状体征：/"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        modal{
            attrs{
                title = if(editingMedicalRecord.id.isNullOrBlank()) "增加医案" else "修改医案"
                visible = showEditForm
                onOk = {
                    message.loading("正在保存")
                    ctx.save(editingMedicalRecord,{ resp->
                        if(resp.ok()){
                            history.push("${urlBase}/smartTcm/diagnosis/${resp.data?.id}")
                        }else{
                            message.error("保存失败，${resp.message}")
                        }
                    },{
                        console.log(it)
                        message.error("保存失败，${it.message}")
                    })

                }
                onCancel = {showEditForm=false}
            }
            form {
                attrs{
                    layout = "horizontal"
                }
                formItem {
                    attrs{
                        label = "患者姓名"
                    }
                    input {
                        attrs {
                            value = editingMedicalRecord?.patientName?:""
                            placeholder = "请填写患者姓名"
                            onChange = {event: dynamic ->
                                val _editing = Object.assign(MedicalRecord(), editingMedicalRecord)
                                _editing.patientName = event.target.value as String
                                _editing.title = "${event.target.value as String}诊治记录"
                                editingMedicalRecord = _editing
                            }
                        }
                    }
                }

                formItem {
                    attrs{
                        label = "患者性别"
                    }
                    radioGroup {
                        attrs {
                            value = editingMedicalRecord.patientSex?.getLiteral()
                            onChange = { event: dynamic ->
                                val _editing = Object.assign(MedicalRecord(), editingMedicalRecord)
                                _editing.patientSex = MedicalRecordPatientSex.valueOf(event.target.value as String)
                                editingMedicalRecord = _editing
                            }
                            options = MedicalRecordPatientSex.values().map { CascadedOption(it.getLiteral(), it.getLiteral()) }
                                .toTypedArray().toJsObject()
                        }
                    }
                }

                formItem {
                    attrs{
                        label = "患者年龄"
                    }
                    input {
                        attrs {
                            type = "number"
                            value = editingMedicalRecord.patientAge
                            placeholder = "请填写患者年龄"
                            onChange = {event: dynamic ->
                                val value = event.target.value as String
                                val _editing = Object.assign(MedicalRecord(), editingMedicalRecord)
                                _editing.patientAge = if(value.isNullOrBlank()) null else value.toInt()
                                editingMedicalRecord = _editing
                            }
                        }
                    }
                }
            }
        }
    }
}
